import bemBlock from "@gik/core/utils/bemBlock";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";
import CompetitorsPreview from "./CompetitorsPreview";

const blockName = "competitors-preview-section";

function CompetitorsPreviewSection(): React.ReactElement {
	const bem = bemBlock(blockName);

	return (
		<PageSection variant="lightblue" className={bem()} contained>
			<CompetitorsPreview />
		</PageSection>
	);
}

export default React.memo(CompetitorsPreviewSection);
